export const captureCurrentRoute = (): string => {
  if (typeof window === "undefined") {
    return "/";
  }

  const { hash, pathname, search } = window.location;

  return `${pathname}${search}${hash}`;
};

export const isSafeAuthRoute = (route: string): boolean =>
  route.startsWith("/") && !route.startsWith("//") && !route.includes("\\");

export const isStoreManagementRoute = (route: string): boolean => {
  const storeManagementUrl = process.env.NEXT_PUBLIC_STORE_MANAGEMENT_URL;

  return Boolean(storeManagementUrl) && route === storeManagementUrl;
};
